import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import './style.css';
import { CubeCamera, Environment, OrbitControls, PerspectiveCamera } from '@react-three/drei';
import Ground from './Ground';
import Car from './Car';
import Rings from './Rings';
import Boxes from './Boxes';
import { BlendFunction } from "postprocessing";
import {
  EffectComposer,
  DepthOfField,
  Bloom,
  ChromaticAberration,
} from "@react-three/postprocessing";
import FloatingGrid from './FloatingGrid';

function CarShow() {
  const isMobile = window.innerWidth < 769;
  return (
    <>
      <OrbitControls target={[0, 0.35, 0]} maxPolarAngle={1.45} />
      <PerspectiveCamera makeDefault fov={50} position={isMobile ? [7, 4, 9] : [5, 3, 7]} />
      <color args={[0, 0, 0]} attach="background" />

      <CubeCamera resolution={256} frames={Infinity}>
        {(texture) => (
          <>
            <Environment map={texture} />
            <Car />
          </>
        )}
      </CubeCamera>

      <spotLight
        color={[1, 0.25, 0.7]}
        intensity={1.5}
        angle={0.6}
        penumbra={0.5}
        position={[5, 5, 0]}
        castShadow
        shadow-bias={-0.0001}
      />
      <spotLight
        color={[0.14, 0.5, 1]}
        intensity={2}
        angle={0.6}
        penumbra={0.5}
        position={[-5, 5, 0]}
        castShadow
        shadow-bias={-0.0001}
      />
      <Ground />
      <Boxes />
      <FloatingGrid />
      <Rings />

      <EffectComposer>
        <DepthOfField focusDistance={0.0035} focalLength={0.01} bokehScale={5} height={480} />
        <Bloom
          blendFunction={BlendFunction.ADD}
          intensity={1.3} // The bloom intensity.
          width={300} // render width
          height={300} // render height
          kernelSize={5} // blur kernel size
          luminanceThreshold={0.55} // luminance threshold. Raise this value to mask out darker elements in the scene.
          luminanceSmoothing={0.025} // smoothness of the luminance threshold. Range is [0, 1]
        />
        <ChromaticAberration
          blendFunction={BlendFunction.NORMAL} // blend mode
          offset={[0.0005, 0.0012]} // color offset
        />
      </EffectComposer>
    </>
  )
}

const App = () => {
  return (
    <Suspense fallback={<div className='loadingScreen'>loading</div>} >
      <Canvas shadows>
        <CarShow />
      </Canvas>
      <div className='headerText'>
        Just some cool stuff I made in Three.js
        <p>You can rotate it around axes and zoom in and out of the picture</p>
      </div>
    </Suspense >
  )
}

export default App;